import React from "react";
import { LayoutGrid, List, Calendar, Map } from "lucide-react";
import { Constants } from "../../../../utils/constants";

const viewTypes = [
  { type: "grid", Icon: LayoutGrid },
  { type: "list", Icon: List },
  { type: "calendar", Icon: Calendar },
  { type: "map", Icon: Map },
];

const BookingViewToggle = ({ activeView, onViewChange }) => {
  return (
    <div className="inline-flex bg-gray-200 rounded-md">
      {viewTypes.map(({ type, Icon }) => (
        <button
          key={type}
          onClick={() => onViewChange(type)}
          className={`flex items-center justify-center w-10 h-10 transition-all duration-200 ${
            activeView === type ? "text-white shadow-sm" : "text-gray-600 hover:bg-gray-300"
          }`}
          style={activeView === type ? { backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR } : {}}
        >
          <Icon className="w-5 h-5" />
        </button>
      ))}
    </div>
  );
};

export default BookingViewToggle;
